export const SET_FILTERS = "SET_FILTERS";

export function setFilters(filters) {
  return {
    type: SET_FILTERS,
    payload: filters,
  };
}
